export default __webpack_public_path__ + "static/media/actionableInsight.4297b2e7.svg";